import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

// PFM-3029: server-driven confirmed-link offer. The creator typed a username
// and email that fully match one eligible identity; they explicitly choose
// to link access to it (existing password unchanged) or close the dialog and
// choose a new email and username.
const useStyles = makeStyles({
    content: {
        maxWidth: 420,
    },
    bold: {
        fontWeight: 600,
    },
    message: {
        textAlign: 'center',
    },
    spacer: {
        padding: 15,
    },
});

export default function LinkExistingIdentityConfirmDialog({ open, identity, onConfirm, onCancel }) {
    const classes = useStyles();
    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogContent className={classes.content}>
                <Box display="flex" alignItems="center" flexDirection="column">
                    <Typography variant="h5" className={classes.bold}>
                        Link Existing User?
                    </Typography>
                    <div className={classes.spacer} />
                    <div className={classes.message}>
                        A user with this username or email already exists
                        {identity?.username ? ` (${identity.username} - ${identity.email})` : ''}. Do you want to link them to this account? Their password will not change. To create a different user instead, close this dialog and use a new username and email.
                    </div>
                    <div className={classes.spacer} />
                    <Box display="flex" gridGap={12}>
                        <Button variant="contained" color="primary" onClick={onConfirm}>
                            Link Existing User
                        </Button>
                        <Button variant="contained" color="secondary" onClick={onCancel}>
                            Cancel
                        </Button>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    );
}

LinkExistingIdentityConfirmDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    identity: PropTypes.shape({ username: PropTypes.string, email: PropTypes.string, displayName: PropTypes.string }),
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

LinkExistingIdentityConfirmDialog.defaultProps = {
    identity: null,
};
